export default {
  list: [
    {
      title: 'پاسخ مشتری',
      value: 'CLINET_RESPONSE'
    },
    {
      title: 'درانتظار',
      value: 'PENDING'
    },
    {
      title: 'پاسخ داده شده',
      value: 'RESPONDED'
    },

    {
      title: 'بسته شده',
      value: 'CLOSED'
    }
  ],

  values: {
    CLOSED: 'CLOSED',
    RESPONSED: 'RESPONSED',
    PENDING: 'PENDING',
    CLINET_RESPONSE: 'CLINET_RESPONSE'
  }
};
